import { useId } from "@reach/auto-id";
import SectionHeading from "./SectionHeading";
import Image from "components/Image";
import styles from "./Magazine.module.scss";

const Magazine = () => {
  const dekId = useId();

  return (
    <section data-testid="homepage-magazine">
      <SectionHeading
        title="Magazine"
        url="https://www.theatlantic.com/magazine/backissues/"
        analyticsSlug="magazine"
        secondaryLinkText="past issues"
      />
      <div className={styles.grid}>
        <p className={styles.dek} id={dekId}>
          Enjoy unlimited access to all of <em>The Atlantic</em>’s journalism,
          in the print edition and online.
        </p>
        <a
          href="https://www.theatlantic.com/subscribe/magazinemodule1/"
          data-action="click link - magazine - image"
          data-label="subscribe"
          className={styles.imageContainer}
          aria-labelledby={dekId}
        >
          <Image
            alt=""
            src="https://www.theatlantic.com/magazine/images/current-issue.large.jpg"
            width={106}
            height={80}
            lazy={true}
          />
        </a>
      </div>
      <a
        href="https://www.theatlantic.com/subscribe/magazinemodule1/"
        className={styles.button}
        data-action="click button - magazine"
        data-label="subscribe"
      >
        Subscribe
      </a>
    </section>
  );
};

export default Magazine;
